import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLayoutContext } from '../Contexts/LayoutContext';
import { useStoreHook } from '../Hooks/StoreHook';
import DefaultLayout from '../Layouts/DefaultLayout';
import FormResetPassword from '../Components/Form/FormResetPassword';
import { TbLockOpen } from 'react-icons/tb';

const ResetPassword = () => {
    const { t } = useTranslation();
    const { company, loadingCompany } = useLayoutContext();
    const { loadCompanyInfo } = useStoreHook();

    useEffect(() => {
        if (!company && !loadingCompany) {
            loadCompanyInfo();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <DefaultLayout className='bg-gray-50'>
            <section className='h-full flex flex-col items-center justify-center p-4 md:p-6 animate-fade-in'>
                <div className='flex flex-col items-center gap-6 md:gap-8 max-w-lg bg-white shadow-lg shadow-gray-100 rounded-2xl border border-gray-100 p-6 md:p-12 transition-all ease-in-out'>

                    <div className='flex flex-col gap-3 items-center text-center'>
                        <TbLockOpen size={45} className="shrink-0" />
                        <h1 className="text-3xl text-custom-primary font-extrabold leading-none">
                            {t('login.reset_password.title')}
                        </h1>
                        <p className="text-gray-500 font-medium leading-none mx-auto mx-3 md:mx-6 text-lg">
                            {t('login.reset_password.description')}
                        </p>
                    </div>

                    <div className='w-full'>
                        <FormResetPassword />
                    </div>

                </div>
            </section>
        </DefaultLayout>
    );
};

export default ResetPassword;

